import { render, staticRenderFns } from "./SpecialistGeneralInfo.vue?vue&type=template&id=7f04f888&scoped=true"
import script from "./SpecialistGeneralInfo.vue?vue&type=script&lang=js"
export * from "./SpecialistGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./SpecialistGeneralInfo.vue?vue&type=style&index=0&id=7f04f888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04f888",
  null
  
)

export default component.exports